<div id="main-content" *ngIf="introData; else loading" class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent($event)">

  <div [innerHTML]="introData.welcome"></div>

  <div class="intro-center display-flex row-flex">
    <div class="has-background cool-gray-5 has-padding flex-space-ie flex-space flex-100">
      <div class="double-bottom-space double-top-space">
        <button class="bofa--button secondary outlined flex-button" tabindex="-1">Back</button>
        <button class="bofa--button secondary dark-blue" tabindex="-1">Save and continue</button>
      </div>
      <div [innerHTML]="introData.buttons"></div>
    </div>

    <div class="has-background cool-gray-5 has-padding flex-space-ie flex-space flex-100">

      <div class="double-top-space double-bottom-space">
        <div class="level justify">
          <div class="level-item pointer">
            <img alt="" src="assets/Success_Icon.svg"
              class="intro-image has-background  bofa--heading is-3 zoom-button icon-text">
          </div>
          <div class="level-item pointer">
            <img alt="" src="assets/Complete_Icon.svg"
              class="intro-image has-background  bofa--heading is-3 zoom-button icon-text">
          </div>
          <div class="level-item pointer">
            <img alt="" src="assets/Incomplete_icon.svg"
              class="intro-image has-background  bofa--heading is-3 zoom-button icon-text">
          </div>
        </div>
      </div>
      <div [innerHTML]="introData.images"></div>
    </div>

    <div class="has-background cool-gray-5 has-padding flex-100" >
      <label for="input" class="double-top-space "> Field </label>
      <input type="text" class="intro-field-width" aria-hidden="true" id="input" tabindex="-1" />
      <div [innerHTML]="introData.error"></div>
    </div>
  </div>

  <div [innerHTML]="introData.howLong"></div>

  <div class="display-flex row-flex">
    <div class="has-background cool-gray-5 has-padding intro-center flex-space-ie flex-space flex-100">
      <div class="intro-min"><img src="assets/~30 min._icon.svg" alt=""></div>

      <div [innerHTML]="introData.minutes"></div>
    </div>

    <div class="has-background cool-gray-5 has-padding intro-center flex-space-ie flex-space flex-100">
      <div class="double-bottom-space double-top-space">
        <button class="bofa--button secondary outlined" tabindex="-1">Save and finish later</button>
      </div>
      <div [innerHTML]="introData.saveAndFinish"></div>
    </div>

    <div class="has-background cool-gray-5 has-padding flex-100">
      <div class="level justify bottom-space">
        <div class="icon-text">
          <img src="assets/25 icon.svg" alt="">
        </div>
      </div>
      <div [innerHTML]="introData.timeOut"></div>
    </div>
  </div>
  <div [innerHTML]="introData.submit"></div>

  <!-- needed for skip content off focus -->
  <div class="unClickableDiv">
    <input tabindex="-1" type="text" class="trasparentText" aria-hidden="true">
  </div>

</div>

<ng-template #loading>
  Loading Applicant User...
</ng-template>
